import React from 'react';
import PropTypes from 'prop-types';

import t from '../../../../../../../../../../css/global.module.css';
import s from '../../navItemButton.module.css';


const NavItemPic = ({ notifs, data }) => (
  <a
    href={data.link}
    role="button"
    className={`${t['no-underline']} ${t['near-black']} ${s.item}  ${t.pointer}`}
  >
    { notifs }
    <img alt="" src={data.labels.icon.max} />
  </a>
);

NavItemPic.propTypes = {
  notifs: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  data: PropTypes.shape({
    link: PropTypes.string,
    labels: PropTypes.shape({
      icon: PropTypes.shape({
        max: PropTypes.string,
      }),
    }),
  }).isRequired,
};

NavItemPic.defaultProps = {
  notifs: null,
};

export default NavItemPic;
